import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './pages/App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './services/store/index';
import './assets/css/styles.less';
import { AuthContainer } from "context/AuthContext"
import './i18n'; 
ReactDOM.render(
  <Provider store={store}>
    <AuthContainer>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthContainer>
  </Provider>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
